import BaseModule from '../../../javascripts/helpers/baseModule';
import toggleClass from '../../../javascripts/dom/toggleClass';

const classList = {
  expandedWrapper: 'block-media__wrapper--expanded'
};

export default class BlockMedia extends BaseModule {
  constructor(element) {
    super(element, 'block-media', [
      { selector: 'wrapper', id: 'wrapper' },
      { selector: 'graphic-btn', id: 'graphicBtn' }
    ]);
  }

  // triggered once in BaseModule
  init() {
    if (this.elements.graphicBtn) {
      this.elements.graphicBtn.addEventListener('click', (event) => {
        event.preventDefault();
        if (this.elements.wrapper) {
          toggleClass(this.elements.wrapper, classList.expandedWrapper);
        }
      });
    }
  }
}
